var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A181E",
    d: "M2.562 5.375c.379-.379.97-.413 1.388-.104l.12.104L9 10.305l4.93-4.93c.379-.379.971-.413 1.388-.104l.12.104c.378.378.413.97.103 1.387l-.103.12-5.684 5.684c-.379.378-.97.413-1.388.103l-.12-.103-5.684-5.684c-.416-.416-.416-1.091 0-1.507z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.ec11b5d2794ebc9e85a2d298a5dca22e.svg";
export { ForwardRef as ReactComponent };